import { Icon } from "@iconify/react/dist/iconify.js"
import { toolTipAtrributes } from "../../utils"
import i18n from "../../langsconfig/i18n"
import React, { useState } from "react"
import type {
    CRRenderProps,
    BlockProps,
    InlineProps,
    ImageProps,
    LinkTagProps,
    EmailTagProps,
    CRIconProps,
    CRButtonProps
} from "./types"

import noData from "../../assets/images/no-data.png"

// Re-export types for external use
export type { TooltipPosition } from "./types"
export type {
    CRRenderProps,
    BlockProps,
    InlineProps,
    ImageProps,
    LinkTagProps,
    EmailTagProps,
    CRIconProps
} from "./types"

// Components
export const CRRender: React.FC<CRRenderProps> = ({ isRender = true, children }) => (
    <>  {!!isRender ? children : null}  </>
)

export const Block: React.FC<BlockProps> = ({
    isRender = true,
    ref,
    className,
    children,
    onClick,
    tooltipName,
    tooltipPos = "top"
}) =>
    <CRRender isRender={isRender}>
        <div {...(toolTipAtrributes(tooltipName, tooltipPos) as any)} onClick={() => onClick?.()} className={className} ref={ref as any}   >{children}</div>
    </CRRender>

export const Inline: React.FC<InlineProps> = ({
    isRender = true,
    className,
    children,
    onClick
}) =>
    <CRRender isRender={isRender}>
        <span onClick={() => onClick?.()} className={className}>{children}</span>
    </CRRender>

export const Image: React.FC<ImageProps & { placeholder: string }> = ({ className, src, onClick, placeholder }) =>
    <>
        <CRRender isRender={!!src}>
            <img onClick={() => onClick?.()} src={src}
                className={className} alt=""
                onError={(e) => {
                    e.currentTarget.src = placeholder
                    e.currentTarget.alt = i18n.t("no-data")
                    e.currentTarget.title = i18n.t("no-data")
                }} />
        </CRRender>

        <CRRender isRender={!src}>
            {i18n.t("no-data")}
        </CRRender>
    </>


export const LinkTag: React.FC<LinkTagProps> = ({ isRender = true, className = "", path = "" }) => {
    const link = path.includes("http") ? path : `http://${path}`
    return (
        <>
            <Block isRender={!!path} onClick={() => window.open(link, "_blank")} className={`${className} link cta-click`} >
                <div {...(toolTipAtrributes(path, "top") as any)}>
                    {i18n.t("click-to-open")}
                </div>
            </Block>
            <CRRender isRender={!path}>
                {i18n.t("no-data")}
            </CRRender>
        </>
    )
}

export const EmailTag: React.FC<EmailTagProps> = ({ to = "" }) =>
    <CRRender isRender={!!to}>
        <a {...(toolTipAtrributes(to, "top") as any)} target="_blank" rel="noreferrer" href={`mailto:${to}`} className={`link cta-click`} >{i18n.t("sent-mail")}</a>
    </CRRender>

export const CRIcon: React.FC<CRIconProps> = ({ icon, isRender = true, className, onClick }) =>
    <CRRender isRender={isRender}>
        <Icon onClick={() => onClick?.()} className={className} icon={icon} />
    </CRRender>



export const CRButton: React.FC<CRButtonProps> = ({ children, isRender = true, className, title, loading, disabled = loading, onClick }) =>
  <CRRender isRender={isRender}>
    <button onClick={() => disabled ? null : onClick?.()} className={className} disabled={disabled} title={title}>
      <CRIcon icon={"codex:loader"} width={20} height={20} color="#fff" className="btn-icon" isRender={loading} />
      <CRRender isRender={!!title} children={title} />
      <CRRender isRender={!!children} children={children} />
    </button>
  </CRRender>